import WindowHandler from "@/ts/components/Handlers/WindowHandler";
import FunctionHandler from "@/ts/components/Handlers/FunctionHandler";
import ShariffLinkGeneratorFactory from "@/ts/components/Shariff/ShariffLinkGeneratorFactory";
import ShariffInjector from "@/ts/components/Shariff/ShariffInjector";
import FrontendHandler from "@/ts/components/Handlers/FrontendHandler";
import EtSlider from "@/ts/components/EtSlider";
import EtPersonalJson from "@/ts/components/EtPersonalJson";
import lightGallery from 'lightgallery';
import {formSubmitHandler_AddToCart_MultipleProducts} from "@/ts/components/artikelFunctions";

// Plugins ... enable plugin css in vbsr2/src/scss/artikel/_artikel_detail__lightgallery.scss
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import {BootstrapViewportEnum} from "@/ts/components/Enums/BootstrapViewportEnum";
import {initAllElementArtikel} from "@/ts/elements/artikel/element_artikel";

interface AdditionalData {
    add: any[];
    view: any[];
    wish: any[];
}
declare var additional_data: AdditionalData;

export default function (vwtype: string, vwname: string): void {
    const resizeFunctionHandler: FunctionHandler = new FunctionHandler();

    if (!window.etData.defaultWishlistId) {
        window.etData.defaultWishlistId = 1;
    }

    WindowHandler.applyViewportClasses();
    let previousViewportWidth: number = window.innerWidth;
    let newViewportWidth: number;
    window.addEventListener("resize", FunctionHandler.debounce(
        resizeFunctionHandler.preventConcurrentExecution(async (): Promise<void> => {
            newViewportWidth = window.innerWidth;
            if (previousViewportWidth !== newViewportWidth) {
                WindowHandler.applyViewportClasses();
                previousViewportWidth = newViewportWidth;
            }
        }, true),
        100
    ));

    FrontendHandler.initWishlistButtons();

    const last_visited_section = document.querySelector<HTMLElement>('#section_last_visited');
    const last_visited_container = document.querySelector<HTMLElement>('#js_artikel_detail_last_visited');
    if (last_visited_container?.getAttribute('data-template-loaded') !== 'true' && last_visited_section) {


        const url = new URL('/json.php', window.location.origin);
        url.searchParams.set('service', 'getRecommendationMarkup');
        url.searchParams.set('pres', window.etData.presenceId.toString());
        url.searchParams.set('context_vw_type', window.etData.vwType);
        url.searchParams.set('context_vw_name', window.etData.vwName);
        url.searchParams.set('context_vw_id', window.etData.vwId.toString());
        url.searchParams.set('lang', window.etData.lang);
        url.searchParams.set('previously_visited', '1');
        url.searchParams.set('template', 'productSlider');

        fetch(url)
            .then(response => response.json())
            .then((data: any) => {
                if (data && data.success && "html" in data && last_visited_container) {

                    last_visited_container.innerHTML = data.html;
                    last_visited_section?.classList.remove('d-none');
                    artikelDetailSeiteAlternatingBackground();

                    // take care of sliders and slider buttons
                    EtSlider.initAllSliders();
                    // regular click handlers
                    initAllElementArtikel();

                    if ("tracking" in data) {
                        let trackingData = JSON.parse(data.tracking);
                        if (typeof trackingData.add !== "undefined") {
                            additional_data.add = {...additional_data.add, ...trackingData.add};
                        }
                        if (typeof trackingData.view !== "undefined") {
                            additional_data.view = {...additional_data.view, ...trackingData.view};
                        }
                        if (typeof trackingData.wish !== "undefined") {
                            additional_data.wish = {...additional_data.wish, ...trackingData.wish};
                        }
                    }
                }
            })
            .catch(error => console.error('Error:', error));
    }

    if (ShariffInjector) {
        const shariff = new ShariffInjector(new ShariffLinkGeneratorFactory());
        shariff.initButtons(window.location.href);
    }

    // @ts-ignore
    document.removeEventListener("et.variantChanged", etVariantChangedEventHandler, {passive: true});
    // @ts-ignore
    document.addEventListener("et.variantChanged", etVariantChangedEventHandler, {passive: true});

    // TODO: nur die sichtbaren Slider initialisieren
    initPdsGallerySliders();

    EtPersonalJson.getInstance().fetchData().then((etPersonalJsonData) => {
        const pageViews = etPersonalJsonData.pageviews || 0;
        if (pageViews > 0) {
            document.querySelectorAll("[data-pageview-counter-value]").forEach((element: Element) => {
                if (element instanceof HTMLElement) {
                    element.innerHTML = pageViews.toString();
                    const parent = element.parentElement;
                    if (parent) {
                        parent.hidden = false;
                    }
                }
            });
        }

        /* Merkliste */
        const pj_merkzettel = etPersonalJsonData.wishlist?.merkzettel || {};
        const firstWishlistId = Number(Object.keys(pj_merkzettel)[0]);
        if (firstWishlistId > 0) {
            window.etData.defaultWishlistId = firstWishlistId;
        }
        // TODO evtl: Merkliste auswählen, anstatt standard-Liste (0) wählen
    });

    document.querySelectorAll(".js_artikel_detail__carousel_addition_add_artikel").forEach((button) => {
        if (!(button instanceof HTMLButtonElement) || !button.disabled) return;

        const formElement = button.form as HTMLFormElement;
        if (!formElement) {
            console.error("No form element found for button", {button});
            return;
        }
        button.disabled = false;

        formElement.addEventListener("submit", formSubmitHandler_AddToCart_MultipleProducts);
    });

    // Zoom functionality for swiper slider
    // Function to handle image zoom functionality
    function imageZoom(img: HTMLImageElement): void {
        if (!(img instanceof HTMLImageElement)) return;
        // Retrieve necessary elements

        const resizedImageForZoom = img.dataset.zoomImage;
        const imageForZoomRealWidth = Number(img.dataset.zoomImageWidth || 0);
        const imageForZoomRealHeight = Number(img.dataset.zoomImageHeight || 0);

        //make sure the image selected belongs to product_detail page
        const zoomBox = document.getElementById('zoomBox') as HTMLElement;
        const generalParent = document.querySelector('.artikel_detail__buybox_s2') as HTMLElement;
        if (!zoomBox || !zoomBox.parentElement || !generalParent) {
            console.error('Invalid zoomBox element');
            return;
        }

        const zoomBoxParent = zoomBox.parentElement;
        const containerWidth = generalParent.offsetWidth || 0;

        // Check if any required elements are missing
        if (!containerWidth) {
            console.error('Invalid containerWidth');
            return;
        }

        let lens: HTMLElement | null = document.querySelector(".artikel_detail__img-zoom-lens");
        let cx: number;
        let cy: number;

        if (!lens) {
            lens = document.createElement('div');
            lens.classList.add('artikel_detail__img-zoom-lens');
        }

        if (resizedImageForZoom && zoomBoxParent && img) {
            const aspectRatio = imageForZoomRealHeight / imageForZoomRealWidth;
            zoomBoxParent.style.width = Math.ceil(containerWidth) + "px";
            zoomBoxParent.style.height = Math.ceil(containerWidth * aspectRatio) + "px";

            img.insertAdjacentElement('beforebegin', lens);
            // Calculate the ratio between zoomBox DIV and lens

            cx = Math.round((zoomBox.offsetWidth / lens.offsetWidth) / 1.5 * 100) / 100;
            cy = Math.round((zoomBox.offsetHeight / lens.offsetHeight) / 1.5 * 100) / 100;

            // Execute a function when someone moves the cursor over the image, or the lens
            // TODO: event listener nur einmal registrieren
            img.addEventListener("mousemove", moveLens);

            function moveLens(e: MouseEvent): void {
                // Prevent any other actions that may occur when moving over the image
                e.preventDefault();

                // get cursor position relative to the image
                const a = img.getBoundingClientRect();
                // Calculate lens position
                const pos = {
                    x: e.pageX - a.left - window.scrollX,
                    y: e.pageY - a.top - window.scrollY
                };
                let x = pos.x;
                let y = pos.y;

                if (lens && typeof lens.offsetWidth !== 'undefined') {
                    x -= (lens?.offsetWidth / 1.5); // Adjusting for lens width
                    y -= (lens.offsetHeight / 1.5); // Adjusting for lens height
                    // Prevent the lens from being positioned outside the image
                    x = Math.round(Math.min(Math.max(x, 0), img.width - lens.offsetWidth));
                    y = Math.round(Math.min(Math.max(y, 0), img.height - lens.offsetHeight));
                    lens.style.left = `${x}px`;
                    lens.style.top = `${y}px`;
                }

                // Display what the lens "sees"
                if (zoomBox && img && resizedImageForZoom) {
                    zoomBox.style.backgroundImage = `url('${resizedImageForZoom}')`;
                    zoomBox.style.backgroundSize = `${img.width * cx}px auto`;
                    zoomBox.style.backgroundPosition = `-${x * cx}px -${y * cy}px`;
                }
            }
        }
    }

    // Function to remove zoom effect
    function removeZoom() {
        let lens = document.querySelector(".artikel_detail__img-zoom-lens") as HTMLElement;
        if (lens && lens.parentNode) {
            lens.parentNode.removeChild(lens);
        }

        let zoomBox = document.getElementById("zoomBox") as HTMLElement;
        if (zoomBox && zoomBox.parentElement) {
            zoomBox.setAttribute('style', '');
            zoomBox.parentElement.setAttribute('style', '');
        }
    }

    // Add event listeners to all images with zoom functionality

    document.querySelectorAll<HTMLImageElement>("img.js_zoomImg[data-zoom-image]").forEach((img) => {
        // Add mouseenter and mouseout event listeners
        img.addEventListener('mouseenter', () => {
            imageZoom(img);
        });
        img.addEventListener('mouseout', () => {
            removeZoom();
        });
        img.addEventListener('click', () => {
            removeZoom();
        });
    });

    const modalBodyElement = document.querySelector('.modal-body');
    // Preventing the lightbox function to be triggered more than once
    if ((modalBodyElement && modalBodyElement.getAttribute('data-template-loaded') === 'true')) {
        return;
    } else {
        // If no element with the class 'modal-body' exists start the lightbox
        const lightBoxImages = document.querySelectorAll<HTMLImageElement>("img.js_zoomImg[data-lightbox-image]");

        // Open lightGallery when an image is clicked
        lightBoxImages.forEach((img, index) => {
            img.addEventListener('click', activateLightBox);

            // Activate Lightbox when no modal is present.
            function activateLightBox() {
                // Prepare the dynamic elements for the lightGallery
                const dynamicEl = Array.from(lightBoxImages)
                    .filter(FrontendHandler.isVariantOfElementActive)
                    .map(img => ({
                        src: img.dataset.lightboxImage,
                        thumb: img.dataset.lightboxThumbnail || img.src,
                        subHtml: `<div class="lightGallery-captions"><h4>${img.alt}</h4></div>`,
                        subHtmlUrl: img.dataset.subHtmlUrl || ''
                    }));

                // Initialize lightGallery with dynamic elements
                const inlineGallery = lightGallery(document.body, {
                    plugins: [lgThumbnail, lgZoom],
                    dynamic: true,
                    licenseKey: '415B960F-32AF-4601-96E6-60E098F7A0FE',
                    closable: true,
                    slideDelay: 100,
                    dynamicEl: dynamicEl,
                    showCloseIcon: true,
                    controls: true,
                    hideScrollbar: true,
                });

                // Open the gallery at the specified index
                const index = 0;
                inlineGallery.openGallery(index);

                // Clean up lightGallery container divs after use
                document.body.addEventListener('click', function (event) {
                    const target = event.target as HTMLElement;
                    if (target?.classList?.contains('lg-close')) {
                        const lgContainer = document.querySelector('.lg-container');
                        if (lgContainer) {
                            lgContainer.remove();
                        }
                    }
                });
            }

        });
    }

    WindowHandler.initializeViewportListener();
    const stickyPriceBoxes = document.querySelectorAll('.element_artikel_price2_sticky');
    const ehiContainer = document.querySelector<HTMLElement>('.wwk-sidebar--mobile--bottom');
    const trustedShopsContainer = document.querySelector<HTMLElement>("[id^='trustbadge-container-']");
    const emmaChatWidget = document.querySelector<HTMLElement>('.emma-chat-widget');

    document.addEventListener(
        'scroll',
        FunctionHandler.debounce(() => {
            stickyPriceBoxes.forEach((stickyPriceBox) => {
                if (stickyPriceBox.closest('.vproduct:is([hidden])')) return;
                let warenkorbButton = document.querySelector(
                    '.vproduct:not([hidden]) .element_artikel_warenkorb:not(.element_artikel_warenkorb_sticky) .element_artikel_warenkorb__a2c'
                );
                if(!warenkorbButton) {
                    warenkorbButton = document.querySelector(
                        '.element_artikel_warenkorb:not(.element_artikel_warenkorb_sticky) .element_artikel_warenkorb__a2c'
                    );
                }
                if(!warenkorbButton) return;
                const rect = warenkorbButton.getBoundingClientRect();
                const currentViewport = WindowHandler.getCurrentBootstrapViewport();
                const isMobile = [
                    BootstrapViewportEnum.MD_MIN,
                    BootstrapViewportEnum.SM_MIN,
                    BootstrapViewportEnum.XS_MIN,
                ].includes(currentViewport);
                const isBelowButton = rect.top < 0;
                if (!isBelowButton) {
                    stickyPriceBox.classList.add('d-none');
                    if (ehiContainer) ehiContainer.hidden = false;
                    if (trustedShopsContainer) trustedShopsContainer.hidden = false;
                    if (isMobile && emmaChatWidget) emmaChatWidget.hidden = false;
                } else {
                    stickyPriceBox.classList.remove('d-none');
                    if (ehiContainer) ehiContainer.hidden = true;
                    if (trustedShopsContainer) trustedShopsContainer.hidden = true;
                    if (isMobile && emmaChatWidget) emmaChatWidget.hidden = true;
                }
            });
        }, 100, true)
    );


    function initArtikelNotification() {
        document.querySelectorAll(".artikel_notify_container ").forEach((notificationTarget) => {
            const form = notificationTarget?.querySelector<HTMLFormElement>("form");
            if (form && !form?.dataset?.initialized) {
                form.dataset.initialized = "true";
                form.addEventListener("submit", async (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (form.dataset.vwId && form.dataset.praesenz && form.dataset.acId) {
                        try {
                            await FrontendHandler.loadTemplate2(
                                'artikel/artikel_notifysuccess',
                                notificationTarget.id,
                                {},
                                true,
                                parseInt(form.dataset.vwId),
                                form.dataset.vwType,
                                form.dataset.vwName,
                                parseInt(form.dataset.praesenz),
                                false,
                                form.action,
                                "",
                                parseInt(form.dataset.acId),
                                form.dataset.acType,
                                form.dataset.acName,
                                form
                            ).then(() => {
                                initArtikelNotification();
                            });
                        } catch (e) {

                        }
                    }
                });
            }
        });
    }
    initArtikelNotification();
}

function initPdsGallerySliders(variantId?: number) {
    const dataAttributeValue = typeof variantId === "number" && variantId > 0 ? `="${variantId}"` : '';
    const selector = `[data-sync-slider-main${dataAttributeValue}]:not(.swiper-initialized)`;

    document.querySelectorAll(selector).forEach(async (mainSliderElement) => {
        if (!(mainSliderElement instanceof HTMLElement)) return;
        const pid = mainSliderElement.dataset.syncSliderMain;
        const thumbsSliderElement = document.querySelector(`[data-sync-slider-thumbs='${pid}']`);

        let thumbsSliderApi: any = null;
        if (thumbsSliderElement instanceof HTMLElement) {
            try {
                const initSliderResult = await EtSlider.initSlider(thumbsSliderElement);
                thumbsSliderApi = initSliderResult.swiperApi;
            } catch (e) {
                // passt schon
            }
        }

        const mainSliderOptions = EtSlider.getSliderConfig(mainSliderElement);
        if (thumbsSliderApi) {
            mainSliderOptions.thumbs = {
                swiper: thumbsSliderApi,
            };
        }

        // console.debug("initPdsGallerySliders", {mainSliderElement, mainSliderOptions});
        EtSlider.initSlider(mainSliderElement, mainSliderOptions);
    });
}

function etVariantChangedEventHandler(event: CustomEvent): void {
    // {detail: {masterId, variantId}})
    if (!event || !event.detail) return;

    // console.debug("etVariantChangedEventHandler", event.type, event.detail);
    initPdsGallerySliders(event.detail.variantId || 0);
}

export function artikelDetailSeiteAlternatingBackground() {
    document.querySelectorAll('section.artikel_detail__section:not(.d-none)').forEach((el, index) => {
        el.classList.toggle('odd', (index + 1) % 2 === 0);
    });
}
